import { OKTA, RETAIL } from './constants/common';
const APPLICATION_TITLE = 'application.title.';
const LOCAL_HOST = 'http://localhost:'

export const RETAIL_WEB_APP = 'retailWebApp';
export const SIM_WEB_SLUG = 'SIMWeb';
export const SIM_WEB_IMAGE = 'retailWeb';
export const SIM_WEB_TITLE = 'Store_Inventory_Management';
export const SIM_WEB_URL_TEST = 'https://simweb-test.nike.com/';
export const SIM_WEB_URL_PROD = 'https://simweb.nike.com/';
export const DISABLE_SIM = 'disableSIM';

export const SELF_CHECKOUT_DEVICE_ASSIGNMENT = 'selfCheckoutDeviceAssignment';
export const SELF_CHECKOUT_DEVICE_SLUG = 'selfCheckoutDevice';
export const SELF_CHECKOUT_DEVICE_IMAGE = 'selfCheckout';
export const SELF_CHECKOUT_DEVICE_TITLE = 'Self_Checkout_Device_Assignment';
export const SELF_CHECKOUT_DEVICE_URL_TEST = 'https://simweb-test.nike.com/SIMWeb/selfCheckoutDeviceAssignment';
export const SELF_CHECKOUT_DEVICE_URL_PROD = 'https://simweb.nike.com/SIMWeb/selfCheckoutDeviceAssignment';
export const DISABLE_SELF_CHECKOUT = 'disableSelfCheckout';

export const ELECTRONIC_JOURNAL = 'electronicJournal';
export const ELECTRONIC_JOURNAL_SLUG = 'retailPrinting';
export const ELECTRONIC_JOURNAL_IMAGE = 'electronicJournal';
export const ELECTRONIC_JOURNAL_TITLE = 'Electronic_Journal';
export const ELECTRONIC_JOURNAL_URL_TEST = 'https://ej.retailprinting-test.nikecloud.com/';
export const ELECTRONIC_JOURNAL_URL_PROD = 'https://ej.retailprinting-prod.nikecloud.com/';
export const ELECTRONIC_JOURNAL_URL_TEST_CHINA = 'https://ej.c4c-retail-comm-svc-test.nikecloud.com.cn/';
export const ELECTRONIC_JOURNAL_URL_PROD_CHINA = 'https://ej.c4c-retail-comm-svc-prod.nikecloud.com.cn/';
export const DISABLE_EJ = 'disableEJ';

export const NIKE_CASH = 'nikeCash';
export const NIKE_CASH_SLUG = 'nikeCash';
export const NIKE_CASH_IMAGE = 'nikeCash';
export const NIKE_CASH_TITLE = 'Nike_Cash';
export const NIKE_CASH_URL_TEST = 'https://rcf-cash-frontend.retail-cash-test.nikecloud.com';
export const NIKE_CASH_URL_PROD = 'https://rcf-cash-frontend.retail-cash-prod.nikecloud.com';
export const DISABLE_NIKE_CASH = 'disableNikeCash';
export const DISABLE_CASH_MANAGEMENT = 'disableCashManagement';

export const STORE_OPERATIONS_REPORTING = 'storeOperationsReporting';
export const STORE_OPERATIONS_REPORTING_SLUG = 'storeOperationsReporting';
export const STORE_OPERATIONS_REPORTING_IMAGE = 'storeOperationsReporting';
export const STORE_OPERATIONS_REPORTING_TITLE = 'Store_Operations_Reporting';
export const STORE_OPERATIONS_REPORTING_URL_TEST = 'https://rcf-reporting-ui.rcf-reporting-test.nikecloud.com/';
export const STORE_OPERATIONS_REPORTING_URL_PROD = 'https://rcf-reporting-ui.rcf-reporting-prod.nikecloud.com/';
export const DISABLE_SOR = 'disableSOR';

export const ATHLETE_MANAGEMENT = 'athleteManagement';
export const ATHLETE_MANAGEMENT_SLUG = 'athleteManagement';
export const ATHLETE_MANAGEMENT_IMAGE = 'athleteManagement';
export const ATHLETE_MANAGEMENT_TITLE = 'Athlete_Management';
export const ATHLETE_MANAGEMENT_URL_TEST = 'https://retail-user-mgmt-ui.wfmathletedev-test.nikecloud.com';
export const ATHLETE_MANAGEMENT_URL_PROD = 'https://retail-user-mgmt-ui.wfmathletedev-test.nikecloud.com';
export const DISABLE_ATHLETE_MANAGEMENT = 'disableAthleteManagement';

export const STORE_HOURS = 'storeHours';
export const STORE_HOURS_SLUG = 'storeHours';
export const STORE_HOURS_IMAGE = 'storeHours';
export const STORE_HOURS_TITLE = 'Store_Hours';
export const STORE_HOURS_URL_TEST = 'https://rbh-special-hours-ui.rbh-robots-test.nikecloud.com';
export const STORE_HOURS_URL_PROD = 'https://rbh-special-hours-ui.rbh-robots-prod.nikecloud.com';
export const DISABLE_STORE_HOURS = 'disableStoreHours';

export const EMPLOYEE_MAINTENANCE = 'employeeMaintenance';
export const EMPLOYEE_MAINTENANCE_SLUG = 'employeeMaintenance';
export const EMPLOYEE_MAINTENANCE_IMAGE = 'employeeMaintenance';
export const EMPLOYEE_MAINTENANCE_TITLE = 'Employee_Maintenance';
export const EMPLOYEE_MAINTENANCE_URL_TEST = 'https://retail-employee-store-transfer.store-test.nikecloud.com/';
export const EMPLOYEE_MAINTENANCE_URL_PROD = 'https://retail-employee-store-transfer.store-prod.nikecloud.com/';
export const DISABLE_EMPLOYEE_MAINTENANCE = 'disableEmployeeMaintenance';

const appsConfig = {
  [RETAIL_WEB_APP]: {
    i18nKey: `${APPLICATION_TITLE}${RETAIL_WEB_APP}`,
    slug: SIM_WEB_SLUG,
    image: SIM_WEB_IMAGE,
    title: SIM_WEB_TITLE,
    adGroups: [
      'Application.SIM.Web.Users'
    ],
    isChinaConfig: true,
    urls:{
      prod: SIM_WEB_URL_PROD,
      test: SIM_WEB_URL_TEST,
      develop: `${LOCAL_HOST}3001/`,
      chinaTest: SIM_WEB_URL_TEST,
      chinaProd: SIM_WEB_URL_PROD
    },
    enabled: true,
    display: true,
    auth: [OKTA, RETAIL],
    minimumRoleLevel: 20
  },
  [SELF_CHECKOUT_DEVICE_ASSIGNMENT]: {
    i18nKey: `${APPLICATION_TITLE}${SELF_CHECKOUT_DEVICE_ASSIGNMENT}`,
    slug: SELF_CHECKOUT_DEVICE_SLUG,
    image: SELF_CHECKOUT_DEVICE_IMAGE,
    title: SELF_CHECKOUT_DEVICE_TITLE,
    isChinaConfig: true,
    urls: {
      prod: SELF_CHECKOUT_DEVICE_URL_PROD,
      test: SELF_CHECKOUT_DEVICE_URL_TEST,
      develop: `${LOCAL_HOST}3001/SIMWeb/selfCheckoutDeviceAssignment`,
      chinaTest: SELF_CHECKOUT_DEVICE_URL_TEST,
      chinaProd: SELF_CHECKOUT_DEVICE_URL_PROD
    },
    enabled: true,
    display: true,
    auth: [RETAIL],
    minimumRoleLevel: 40
  },
  [ELECTRONIC_JOURNAL]: {
    i18nKey: `${APPLICATION_TITLE}${ELECTRONIC_JOURNAL}`,
    slug: ELECTRONIC_JOURNAL_SLUG,
    image: ELECTRONIC_JOURNAL_IMAGE,
    title: ELECTRONIC_JOURNAL_TITLE,
    adGroups: [
      'App.ElectronicJournal.GLOBAL',
      'App.ElectronicJournal.GEO.APLA',
      'App.ElectronicJournal.ADMIN',
      'App.ElectronicJournal.EMEA',
      'App.ElectronicJournal.GEO.GC',
      'App.ElectronicJournal.GEO.NA'
    ],
    isChinaConfig: true,
    urls:{
      prod: ELECTRONIC_JOURNAL_URL_PROD,
      test: ELECTRONIC_JOURNAL_URL_TEST,
      develop: `${LOCAL_HOST}1234/`,
      chinaTest: ELECTRONIC_JOURNAL_URL_TEST_CHINA,
      chinaProd: ELECTRONIC_JOURNAL_URL_PROD_CHINA
    },
    enabled: true,
    display: true,
    auth: [OKTA, RETAIL],
    minimumRoleLevel: 30,
    banner:{
      display : true,
      i18nKey : 'New'
    }
  },
  [NIKE_CASH]: {
    i18nKey: `${APPLICATION_TITLE}${NIKE_CASH}`,
    slug: NIKE_CASH_SLUG,
    image: NIKE_CASH_IMAGE,
    title: NIKE_CASH_TITLE,
    isChinaConfig: true,
    urls:{
      prod: NIKE_CASH_URL_PROD,
      test: NIKE_CASH_URL_TEST,
      develop: `${LOCAL_HOST}1234/`,
      chinaTest: NIKE_CASH_URL_TEST,
      chinaProd: NIKE_CASH_URL_PROD
    },
    enabled: true,
    display: true,
    auth: [RETAIL],
    minimumRoleLevel: 30,
    banner:{
      display : true,
      i18nKey : 'New'
    }
  },
  [STORE_OPERATIONS_REPORTING]: {
    i18nKey: `${APPLICATION_TITLE}${STORE_OPERATIONS_REPORTING}`,
    slug: STORE_OPERATIONS_REPORTING_SLUG,
    image: STORE_OPERATIONS_REPORTING_IMAGE,
    title: STORE_OPERATIONS_REPORTING_TITLE,
    isChinaConfig: true,
    urls:{
      prod: STORE_OPERATIONS_REPORTING_URL_PROD,
      test: STORE_OPERATIONS_REPORTING_URL_TEST,
      develop: `${LOCAL_HOST}1234/`,
      chinaTest: STORE_OPERATIONS_REPORTING_URL_TEST,
      chinaProd: STORE_OPERATIONS_REPORTING_URL_PROD
    },
    enabled: true,
    display: true,
    auth: [RETAIL],
    minimumRoleLevel: 30,
    banner:{
      display : true,
      i18nKey : 'New'
    }
  },
  [ATHLETE_MANAGEMENT]: {
    i18nKey: `${APPLICATION_TITLE}${ATHLETE_MANAGEMENT}`,
    slug: ATHLETE_MANAGEMENT_SLUG,
    image: ATHLETE_MANAGEMENT_IMAGE,
    title: ATHLETE_MANAGEMENT_TITLE,
    isChinaConfig: false,
    urls: {
      prod: ATHLETE_MANAGEMENT_URL_PROD,
      test: ATHLETE_MANAGEMENT_URL_TEST,
      develop: `${LOCAL_HOST}3001`,
      chinaTest: '',
      chinaProd: ''
    },
    enabled: false,
    display: false,
    auth: [RETAIL],
    minimumRoleLevel: 30,
    banner: {
      display: true,
      i18nKey: 'Coming_Soon'
    }
  },
  [STORE_HOURS]: {
    i18nKey: `${APPLICATION_TITLE}${STORE_HOURS}`,
    slug: STORE_HOURS_SLUG,
    image:  STORE_HOURS_IMAGE,
    title:  STORE_HOURS_TITLE,
    adGroups: [
      'App.StoreHours.Users.ALL',
      'App.StoreHours.Users.APLA',
      'App.StoreHours.Users.NA',
      'App.StoreHours.Users.GC',
      'App.StoreHours.Users.EMEA'
    ],
    isChinaConfig: true,
    promptBeforeExit: true,
    urls: {
      prod: STORE_HOURS_URL_PROD,
      test: STORE_HOURS_URL_TEST,
      develop: `${LOCAL_HOST}3001`,
      chinaTest: STORE_HOURS_URL_TEST,
      chinaProd: STORE_HOURS_URL_PROD
    },
    enabled: true,
    display: true,
    auth: [OKTA, RETAIL],
    minimumRoleLevel: 40,
    banner: {
      display: true,
      i18nKey: 'New'
    }
  },
  [EMPLOYEE_MAINTENANCE]: {
    i18nKey: `${APPLICATION_TITLE}${EMPLOYEE_MAINTENANCE}`,
    slug: EMPLOYEE_MAINTENANCE_SLUG,
    image: EMPLOYEE_MAINTENANCE_IMAGE,
    title: EMPLOYEE_MAINTENANCE_TITLE,
    isChinaConfig: false,
    urls: {
      prod: EMPLOYEE_MAINTENANCE_URL_PROD,
      test: EMPLOYEE_MAINTENANCE_URL_TEST,
      develop: `${LOCAL_HOST}3001`,
      chinaTest: '',
      chinaProd: ''
    },
    enabled: true,
    display: true,
    auth: [RETAIL],
    minimumRoleLevel: 40,
    banner: {
      display: true,
      i18nKey: 'New'
    }
  }
}

export default appsConfig;
